import React from "react";
import ComplianceSection from "../../components/ComplianceSection/ComplianceSection";

const BusinessCompliance = () => {
  return <ComplianceSection />;
};

export default BusinessCompliance;
